import { z } from 'zod';

import { addressFormSchema as address } from '../AddressForm/Address.schema';
import { firstNameSchema, lastNameSchema, phoneSchema } from '../NameFields';

export const addressesPageSchema = z.object({
    firstName: firstNameSchema,
    lastName: lastNameSchema,
    address,
    phone: phoneSchema,
    isPrimary: z.boolean().optional(),
    useForAllShipments: z.boolean().optional(),
});
